module.exports = __webpack_public_path__ + "img/md5v5.f8cce0a9.png";